import React, { useState, useEffect, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import AdminLayout from '../../components/AdminLayout';
import StatCards from '../../components/StatCards';
import { getAllOffers, createOffer, updateOffer, deleteOffer } from '../../services/api';

var emptyForm = {
  title: '',
  description: '',
  discountValue: '',
  applicableTo: 'all',
  isActive: true,
  hasFirstOrderOnly: true,
};

var isActiveStatus = function (item) {
  return String((item && item.isActive !== undefined ? item.isActive : item && item.status) || 'active').toLowerCase() !== 'false' && String((item && item.status) || 'active').toLowerCase() !== 'inactive';
};

var isScheduled = function (item) {
  var value = item && (item.startDate || item.startsAt || item.scheduledAt);
  return value ? new Date(value) > new Date() : false;
};

var isExpired = function (item) {
  var value = item && (item.endDate || item.endsAt || item.expiryDate || item.expiresAt);
  return value ? new Date(value) < new Date() : false;
};

var getOfferId = function (offer) {
  if (!offer) return '';
  return offer._id || offer.id || '';
};

var normalizeOffer = function (offer) {
  if (!offer) return offer;
  return Object.assign({}, offer, {
    _id: offer._id || offer.id,
    hasFirstOrderOnly: offer.firstOrderOnly !== false && offer.hasFirstOrderOnly !== false,
  });
};

var getOfferListFromResponse = function (res) {
  var payload = res && res.data;
  if (Array.isArray(payload)) return payload;
  if (payload && Array.isArray(payload.data)) return payload.data;
  return [];
};

var discountLabel = function (offer) {
  if (!offer) return '�';
  return offer.discountValue + '% off';
};

var getOfferStatus = function (offer) {
  if (!offer) return 'Draft';
  return offer.isActive ? 'Active' : 'Inactive';
};

var isValidTitle = function (title) {
  if (!title.trim()) return false;
  return /^[a-zA-Z\s]*$/.test(title);
};

var e = React.createElement;

var EyeIcon = function () {
  return e('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    e('path', { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' }),
    e('circle', { cx: 12, cy: 12, r: 3 })
  );
};
var PencilIcon = function () {
  return e('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    e('path', { d: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7' }),
    e('path', { d: 'M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z' })
  );
};
var TrashIcon = function () {
  return e('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    e('polyline', { points: '3 6 5 6 21 6' }),
    e('path', { d: 'M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6' }),
    e('path', { d: 'M10 11v6M14 11v6' }),
    e('path', { d: 'M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2' })
  );
};

var XIcon = function () {
  return e('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
    e('line', { x1: 18, y1: 6, x2: 6, y2: 18 }),
    e('line', { x1: 6, y1: 6, x2: 18, y2: 18 })
  );
};
var css = [
  "@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');",
  ".op-page{padding:20px;width:100%;box-sizing:border-box;font-family:'Outfit',sans-serif;color:#0F172A;}",
  ".page-header-row{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin-bottom:12px;}",
  ".page-header-title-row{display:flex;align-items:center;gap:10px;}",
  ".page-header-icon{display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:14px;background:#FFF7E8;color:#D99A2B;box-shadow:inset 0 0 0 1px rgba(217,154,43,0.16);}",
  ".op-heading{margin:0;font-size:20px;font-weight:800;color:#0F172A;}",
  ".op-subtitle{margin:4px 0 0;color:#8B5CF6;font-size:12px;font-weight:700;}",
  ".op-new-btn{display:inline-flex;align-items:center;gap:6px;border:none;background:linear-gradient(135deg,#6D28D9,#A855F7);color:#fff;border-radius:999px;padding:9px 18px;font-size:13px;font-weight:800;font-family:'Outfit',sans-serif;cursor:pointer;box-shadow:0 6px 18px rgba(109,40,217,0.3);white-space:nowrap;}",
  ".op-group{display:grid;gap:14px;}",
  ".op-field-row{display:grid;grid-template-columns:1fr 1fr;gap:14px;}",
  "@media(max-width:540px){.op-field-row{grid-template-columns:1fr !important;}}",
  ".op-label{display:block;margin-bottom:5px;color:#C4B5FD;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;}",
  ".op-input,.op-select{width:100%;min-height:38px;border:1px solid #312E81;border-radius:11px;padding:10px 12px;background:#FFFFFF;color:#102a33;font-family:'Outfit',sans-serif;font-size:13px;font-weight:600;outline:none;box-sizing:border-box;}",
  ".op-input:focus,.op-select:focus{border-color:#6D28D9;box-shadow:0 0 0 3px rgba(109,40,217,0.2);}",
  ".cs-dropdown-list{max-height:220px;overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none;}",
  ".cs-dropdown-list::-webkit-scrollbar{display:none;}",
  ".op-cs-trigger{width:100%;text-align:left;cursor:pointer;padding:10px 12px;border-radius:11px;border:1px solid rgba(62,124,140,0.28);background:#FFFFFF;color:#102a33;font-family:'Outfit',sans-serif;font-size:13px;font-weight:700;display:flex;justify-content:space-between;align-items:center;box-sizing:border-box;box-shadow:0 1px 2px rgba(15,23,42,0.04);}",
  ".op-cs-trigger:hover{border-color:#3E7C8C;box-shadow:0 0 0 3px rgba(62,124,140,0.14);}",
  ".op-disc-val-row{display:grid;grid-template-columns:1fr auto;gap:10px;align-items:end;}",
  ".op-disc-suffix{padding:10px 14px;background:rgba(109,40,217,0.15);border:1px solid #312E81;border-radius:11px;font-size:13px;font-weight:800;color:#A855F7;}",
  ".op-cb-card{display:flex;align-items:center;gap:10px;padding:12px 14px;border:1.5px solid #312E81;border-radius:12px;background:#20105E;cursor:pointer;user-select:none;}",
  ".op-cb-card.cb-active{border-color:#6D28D9;background:rgba(109,40,217,0.15);}",
  ".op-cb-box{width:18px;height:18px;border-radius:5px;border:2px solid #312E81;display:flex;align-items:center;justify-content:center;flex-shrink:0;}",
  ".op-cb-card.cb-active .op-cb-box{border-color:#6D28D9;background:#6D28D9;}",
  ".op-cb-tick{width:10px;height:10px;display:none;}",
  ".op-cb-card.cb-active .op-cb-tick{display:block;}",
  ".op-cb-name{font-size:13px;font-weight:700;color:#C4B5FD;}",
  ".op-cb-card.cb-active .op-cb-name{color:#FFFFFF;}",
  ".op-cb-sub{font-size:11px;color:#8B5CF6;font-weight:600;margin-top:1px;}",
  ".op-submit-row{display:flex;gap:10px;flex-wrap:wrap;margin:20px -26px -26px;padding:14px 26px 0;background:#20105E;border-top:1px solid rgba(49,46,129,.75);position:sticky;bottom:-26px;z-index:2;}",
  ".op-submit{border:none;background:linear-gradient(135deg,#6D28D9,#A855F7);color:#fff;font-size:13px;font-weight:800;padding:10px 18px;border-radius:11px;cursor:pointer;}",
  ".op-submit:disabled{opacity:0.6;cursor:not-allowed;}",
  ".op-reset{border:1px solid #312E81;background:transparent;color:#A855F7;font-size:13px;font-weight:700;padding:10px 18px;border-radius:11px;cursor:pointer;}",
  ".op-msg{margin-top:4px;font-weight:700;font-size:13px;}",
  ".op-global-msg{margin-bottom:16px;padding:11px 15px;border-radius:11px;font-size:13px;font-weight:700;}",
  ".op-global-msg.success{background:rgba(16,185,129,0.15);color:#86EFAC;border:1px solid rgba(16,185,129,0.3);}",
  ".op-global-msg.error{background:rgba(239,68,68,0.15);color:#FCA5A5;border:1px solid rgba(239,68,68,0.3);}",
  ".op-table-card{background:rgba(255,255,255,0.98);border:1px solid rgba(62,124,140,0.16);border-radius:16px;box-shadow:0 20px 48px rgba(62,124,140,0.12);padding:18px 20px;width:100%;box-sizing:border-box;overflow:hidden;}",
  ".op-count{margin:0 0 14px;font-size:13px;color:#111827;font-weight:700;}",
  ".op-table-wrap{width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;}",
  ".op-table{width:100%;border-collapse:collapse;background:#ffffff;}",
  ".op-table th{padding:10px 12px;text-align:left;vertical-align:middle;color:#2d5f6e;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.6px;border-bottom:1px solid rgba(62,124,140,0.16);white-space:nowrap;background:#f8fafc;}",
  ".op-table td{padding:13px 12px;vertical-align:middle;border-bottom:1px solid rgba(129,140,248,0.12);font-size:13px;color:#111827;}",
  ".op-badge{display:inline-flex;align-items:center;padding:4px 10px;border-radius:999px;font-size:11px;font-weight:700;}",
  ".op-badge.active{background:rgba(52,211,153,0.08);color:#059669;}",
  ".op-badge.inactive{background:rgba(248,113,113,0.10);color:#dc2626;}",
  ".act-menu{position:relative;display:inline-flex;}",
  ".act-menu-btn{width:34px;height:34px;border-radius:10px;border:1px solid rgba(62,124,140,0.18);background:rgba(62,124,140,0.08);color:#2d5f6e;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;}",
  ".act-menu-dd{position:fixed;min-width:150px;background:#ffffff;border:1px solid rgba(62,124,140,0.16);border-radius:12px;box-shadow:0 16px 40px rgba(109,40,217,0.2);padding:6px;z-index:9999;}",
  ".act-menu-item{width:100%;display:flex;align-items:center;gap:10px;padding:9px 10px;border:none;background:transparent;color:#334155;font-size:13px;font-weight:600;border-radius:8px;cursor:pointer;text-align:left;}",
  ".act-menu-item:hover{background:rgba(62,124,140,0.08);}",
  ".act-menu-delete{color:#ef4444;}",
  ".op-empty{padding:36px;text-align:center;color:#64748b;font-weight:700;font-size:14px;background:#f8fafc;border:1px dashed rgba(62,124,140,0.18);border-radius:14px;}",
  ".op-loading{padding:36px;text-align:center;color:#2d5f6e;font-weight:700;font-size:14px;}",
  ".op-modal-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(18,10,58,0.85);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);display:flex;align-items:center;justify-content:center;padding:20px;z-index:9999;}",
  ".op-modal{width:min(480px,100%);background:#20105E;border-radius:20px;padding:26px;box-shadow:0 22px 56px rgba(109,40,217,0.3);max-height:calc(100vh - 96px);overflow-y:auto;border:1px solid #312E81;box-sizing:border-box;}",
  ".op-modal-header{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:20px;}",
  ".op-modal-title{margin:0;font-size:17px;font-weight:800;color:#FFFFFF;}",
  ".op-modal-close{border:none;background:rgba(109,40,217,0.15);color:#A855F7;width:32px;height:32px;border-radius:9px;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;}",
  ".op-modal-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:14px;}",
  ".op-modal-lbl{margin:0 0 3px;font-size:11px;color:#C4B5FD;font-weight:700;text-transform:uppercase;}",
  ".op-modal-val{margin:0;color:#FFFFFF;font-size:14px;font-weight:600;}",
  ".op-confirm-box{width:min(420px,100%);background:#20105E;border-radius:20px;padding:26px;border:1px solid #312E81;}",
  ".op-confirm-actions{display:flex;justify-content:flex-end;gap:10px;margin-top:18px;flex-wrap:wrap;}",
  ".op-confirm-btn{border:none;border-radius:11px;padding:11px 17px;font-size:13px;font-weight:700;cursor:pointer;}",
  ".op-confirm-btn.cancel{background:rgba(109,40,217,0.15);color:#A855F7;}",
  ".op-confirm-btn.confirm{background:linear-gradient(135deg,#6D28D9,#A855F7);color:#fff;}",
  ".op-confirm-btn:disabled{opacity:0.6;cursor:not-allowed;}",
].join('\n');

/* -- Custom Select (matches theme, portaled so it escapes clipped containers) -- */
var CustomSelect = function (props) {
  var value = props.value; var onChange = props.onChange; var options = props.options;
  var os = useState(false); var open = os[0]; var setOpen = os[1];
  var posState = useState({ top: 0, left: 0, width: 0 }); var pos = posState[0]; var setPos = posState[1];
  var triggerRef = useRef();
  var listRef = useRef();

  var openList = function () {
    if (triggerRef.current) {
      var rect = triggerRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 4, left: rect.left, width: rect.width });
    }
    setOpen(true);
  };

  useEffect(function () {
    if (!open) return;
    var handler = function (ev) {
      if (triggerRef.current && triggerRef.current.contains(ev.target)) return;
      if (listRef.current && listRef.current.contains(ev.target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    var reposition = function () {
      if (triggerRef.current) {
        var rect = triggerRef.current.getBoundingClientRect();
        setPos({ top: rect.bottom + 4, left: rect.left, width: rect.width });
      }
    };
    window.addEventListener('scroll', reposition, true);
    window.addEventListener('resize', reposition);
    return function () {
      document.removeEventListener('mousedown', handler);
      window.removeEventListener('scroll', reposition, true);
      window.removeEventListener('resize', reposition);
    };
  }, [open]);

  var selected = options.find(function (o) { return o.value === value; });

  return e('div', { style: { position: 'relative' } },
    e('button', {
      type: 'button',
      ref: triggerRef,
      className: 'op-cs-trigger',
      onClick: function () { if (open) { setOpen(false); } else { openList(); } }
    },
      selected ? selected.label : 'Select',
      e('span', { style: { fontSize: 11, color: '#2d5f6e', marginLeft: 8 } }, '\u25BC')
    ),
    open && createPortal(
      e('div', {
        ref: listRef,
        className: 'cs-dropdown-list',
        style: {
          position: 'fixed', top: pos.top + 'px', left: pos.left + 'px', width: pos.width + 'px',
          background: '#ffffff', border: '1px solid rgba(62,124,140,0.22)',
          borderRadius: 11, zIndex: 999999,
          boxShadow: '0 16px 40px rgba(15,23,42,0.16)',
        }
      },
        options.map(function (o) {
          var isSel = o.value === value;
          return e('div', {
            key: o.value,
            onClick: function () { onChange(o.value); setOpen(false); },
            style: {
              padding: '10px 12px', fontSize: 13, cursor: 'pointer',
              color: isSel ? '#ffffff' : '#102a33',
              background: isSel ? '#3E7C8C' : '#ffffff',
              fontFamily: "'Outfit',sans-serif",
              transition: 'background 0.15s',
            },
            onMouseEnter: function (ev) { if (!isSel) ev.currentTarget.style.background = '#eef8fa'; },
            onMouseLeave: function (ev) { if (!isSel) ev.currentTarget.style.background = '#ffffff'; }
          }, o.label);
        })
      ),
      document.body
    )
  );
};


var Offers = function () {
  var offerState        = useState([]); var offers = offerState[0]; var setOffers = offerState[1];
  var formState         = useState(emptyForm); var form = formState[0]; var setForm = formState[1];
  var editingIdState    = useState(null); var editingId = editingIdState[0]; var setEditingId = editingIdState[1];
  var messageState      = useState({ text: '', type: '' }); var message = messageState[0]; var setMessage = messageState[1];
  var viewingOfferState = useState(null); var viewingOffer = viewingOfferState[0]; var setViewingOffer = viewingOfferState[1];
  var showFormState     = useState(false); var showForm = showFormState[0]; var setShowForm = showFormState[1];
  var showEditModalState= useState(false); var showEditModal = showEditModalState[0]; var setShowEditModal = showEditModalState[1];
  var pendingDeleteState= useState(null); var pendingDeleteOffer = pendingDeleteState[0]; var setPendingDeleteOffer = pendingDeleteState[1];
  var openMenuIdState   = useState(null); var openMenuId = openMenuIdState[0]; var setOpenMenuId = openMenuIdState[1];
  var loadingState      = useState(false); var loading = loadingState[0]; var setLoading = loadingState[1];
  var submittingState   = useState(false); var submitting = submittingState[0]; var setSubmitting = submittingState[1];
  var deletingState     = useState(false); var deleting = deletingState[0]; var setDeleting = deletingState[1];
  var menuPosState      = useState({ top: 0, right: 0 }); var menuPos = menuPosState[0]; var setMenuPos = menuPosState[1];
  var fieldErrorsState  = useState({}); var fieldErrors = fieldErrorsState[0]; var setFieldErrors = fieldErrorsState[1];
  var statusFilterState = useState('all'); var statusFilter = statusFilterState[0]; var setStatusFilter = statusFilterState[1];

  var isAnyModalOpen = !!(showForm || viewingOffer || showEditModal || pendingDeleteOffer);

  useEffect(function () {
    document.body.style.overflow = isAnyModalOpen ? 'hidden' : '';
    return function () { document.body.style.overflow = ''; };
  }, [isAnyModalOpen]);

  var fetchOffers = useCallback(function () {
    setLoading(true);
    getAllOffers()
      .then(function (res) { setOffers(getOfferListFromResponse(res).map(normalizeOffer)); })
      .catch(function (err) {
        var msg = (err.response && err.response.data && err.response.data.message) || 'Failed to load offers.';
        setMessage({ text: msg, type: 'error' });
      })
      .finally(function () { setLoading(false); });
  }, []);

  useEffect(function () { fetchOffers(); }, [fetchOffers]);

  useEffect(function () {
    var handler = function (ev) {
      if (!ev || !ev.target || !ev.target.closest) { setOpenMenuId(null); return; }
      if (ev.target.closest('.act-menu')) return;
      setOpenMenuId(null);
    };
    document.addEventListener('mousedown', handler);
    return function () { document.removeEventListener('mousedown', handler); };
  }, []);

  var setField = function (key, val) {
    setForm(function (prev) { return Object.assign({}, prev, { [key]: val }); });
    if (key === 'title') {
      setFieldErrors(function (prev) {
        return Object.assign({}, prev, {
          title: (!val.trim() || /^[a-zA-Z\s]*$/.test(val)) ? '' : 'Only letters are allowed'
        });
      });
    }
  };

  var activeOffers = offers.filter(function (offer) { return isActiveStatus(offer) && !isExpired(offer); }).length;
  var inactiveOffers = offers.filter(function (offer) { return !isActiveStatus(offer); }).length;
  var expiredOffers = offers.filter(isExpired).length;
  var offerStatCards = [
    { title: 'Total Offers', value: offers.length, description: 'All promotional offers', icon: 'grid', accent: '#d99a2b' },
    { title: 'Active Offers', value: activeOffers, description: 'Currently usable', icon: 'check', accent: '#16a34a' },
    { title: 'Inactive Offers', value: inactiveOffers, description: 'Manually paused', icon: 'pause', accent: '#f59e0b' },
    { title: 'Expired Offers', value: expiredOffers, description: 'Past end date', icon: 'clock', accent: '#ef4444' },
  ];

  var filteredOffers = offers.filter(function (offer) {
    if (statusFilter === 'all') return true;
    if (statusFilter === 'active') return isActiveStatus(offer) && !isExpired(offer);
    if (statusFilter === 'inactive') return !isActiveStatus(offer);
    if (statusFilter === 'expired') return isExpired(offer);
    return true;
  });

  var resetForm = function () {
    setForm(emptyForm); setEditingId(null); setMessage({ text: '', type: '' });
    setFieldErrors({}); setShowForm(false); setShowEditModal(false);
  };


  var validate = function () {
    if (!form.title.trim()) return 'Please enter an offer title.';
    if (!isValidTitle(form.title)) return 'Only letters are allowed';
    if (!form.discountValue || Number(form.discountValue) <= 0) return 'Enter a valid discount percentage.';
    if (Number(form.discountValue) > 100) return 'Percentage cannot exceed 100%.';
    return null;
  };

  var handleSubmit = function (ev) {
    ev.preventDefault();
    var err = validate();
    if (err) { setMessage({ text: err, type: 'error' }); return; }
    setSubmitting(true); setMessage({ text: '', type: '' });

    var payload = {
      title: form.title.trim().replace(/\s+/g, ' '),
      description: form.description.trim(),
      discountValue: Number(form.discountValue),
      applicableTo: 'all',
      isActive: form.isActive,
      firstOrderOnly: true,
    };

    var apiCall = editingId ? updateOffer(editingId, payload) : createOffer(payload);
    apiCall
      .then(function (res) {
        var msg = (res.data && res.data.message) || (editingId ? 'Offer updated.' : 'Offer created.');
        setMessage({ text: msg, type: 'success' }); resetForm(); fetchOffers();
      })
      .catch(function (err) {
        var msg = (err.response && err.response.data && err.response.data.message) || 'Something went wrong.';
        setMessage({ text: msg, type: 'error' });
      })
      .finally(function () { setSubmitting(false); });
  };

  var startEdit = function (offer) {
    var n = normalizeOffer(offer);
    setEditingId(getOfferId(offer));
    setFieldErrors({});
    setForm({
      title: n.title || '',
      description: n.description || '',
      discountValue: String(n.discountValue || ''),
      applicableTo: 'all',
      isActive: n.isActive !== undefined ? n.isActive : true,
      hasFirstOrderOnly: true,
    });
    setMessage({ text: '', type: '' }); setShowForm(false); setShowEditModal(true);
  };

  var confirmDelete = function () {
    if (!pendingDeleteOffer) return;
    setDeleting(true);
    deleteOffer(getOfferId(pendingDeleteOffer))
      .then(function (res) {
        var msg = (res.data && res.data.message) || 'Offer deleted successfully.';
        setMessage({ text: msg, type: 'success' }); setPendingDeleteOffer(null); fetchOffers();
      })
      .catch(function (err) {
        var msg = (err.response && err.response.data && err.response.data.message) || 'Failed to delete offer.';
        setMessage({ text: msg, type: 'error' }); setPendingDeleteOffer(null);
      })
      .finally(function () { setDeleting(false); });
  };

  var toggleMenu = function (id) { setOpenMenuId(function (prev) { return prev === id ? null : id; }); };

  var renderFormFields = function () {
    return e('div', { className: 'op-group' },
      e('div', null,
        e('label', { className: 'op-label' }, 'Offer Title *'),
        e('input', {
          className: 'op-input', type: 'text', value: form.title, placeholder: 'E.g. First Order Special',
          onChange: function (ev) { setField('title', ev.target.value.replace(/[^a-zA-Z\s]/g, '')); }
        }),
        fieldErrors.title ? e('div', { className: 'op-msg', style: { color: '#9d174d' } }, fieldErrors.title) : null
      ),
      e('div', null,
        e('label', { className: 'op-label' }, 'Description'),
        e('textarea', {
          className: 'op-input', rows: 3, value: form.description || '', placeholder: 'Describe this first-order offer',
          onChange: function (ev) { setField('description', ev.target.value); }
        })
      ),
      e('div', { className: 'op-field-row' },
        e('div', null,
          e('label', { className: 'op-label' }, 'Discount Percentage *'),
          e('div', { className: 'op-disc-val-row' },
            e('input', {
              className: 'op-input', type: 'number', min: '1', max: '100', value: form.discountValue, placeholder: 'e.g. 30',
              onChange: function (ev) { setField('discountValue', ev.target.value); }
            }),
            e('div', { className: 'op-disc-suffix' }, '%')
          )
        ),
        e('div', null,
          e('label', { className: 'op-label' }, 'Status'),
          e(CustomSelect, {
            value: form.isActive ? 'true' : 'false',
            onChange: function (val) { setField('isActive', val === 'true'); },
            options: [
              { value: 'true', label: 'Active' },
              { value: 'false', label: 'Inactive' }
            ]
          })
        )
      ),
      e('div', { className: 'op-cb-card cb-active' },
        e('div', { className: 'op-cb-box' },
          e('svg', { className: 'op-cb-tick', viewBox: '0 0 10 10', fill: 'none' },
            e('polyline', { points: '1.5 5 4 7.5 8.5 2', stroke: '#fff', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' })
          )
        ),
        e('div', null,
          e('div', { className: 'op-cb-name' }, 'First Order Offer'),
          e('div', { className: 'op-cb-sub' }, 'This offer applies only to customers placing their first order.')
        )
      ),
      message.text
        ? e('div', { className: 'op-msg', style: { color: message.type === 'success' ? '#047857' : '#9d174d' } }, message.text)
        : null
    );
  };

  return e(AdminLayout, null,
    e('style', null, css),
    e('div', { className: 'op-page' },
      e('div', { className: 'page-header-row' },
        e('div', null,
          e('div', { className: 'page-header-title-row' },
            e('div', { className: 'page-header-icon' },
              e('svg', { width: '20', height: '20', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
                e('path', { d: 'M12 2a9 9 0 0 0-9 9v5l-1 2h20l-1-2v-5a9 9 0 0 0-9-9z' })
              )
            ),
            e('div', null,
              e('h1', { className: 'op-heading' }, 'Promotional Offers'),
              e('p', { className: 'op-subtitle' }, 'Manage first-order percentage offers only.')
            )
          )
        ),
        e('button', {
          type: 'button', className: 'op-new-btn',
          onClick: function () {
            setForm(emptyForm); setEditingId(null); setMessage({ text: '', type: '' });
            setShowEditModal(false); setShowForm(true);
          }
        }, '+ Add Offer')
      ),
      e(StatCards, { cards: offerStatCards }),



      (message.text && !showForm && !showEditModal)
        ? e('div', { className: 'op-global-msg ' + message.type }, message.text)
        : null,


      e('div', { className: 'op-table-card' },
        e('p', { className: 'op-count' }, statusFilter === 'all' ? 'All Offers (' + filteredOffers.length + ')' : (statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1)) + ' Offers (' + filteredOffers.length + ')'),
        loading
          ? e('div', { className: 'op-loading' }, 'Loading offers\u2026')
          : filteredOffers.length === 0
            ? e('div', { className: 'op-empty' }, 'No promotional offers yet. Click ', e('strong', null, '+ New Offer'), ' to add one.')
            : e('div', { className: 'op-table-wrap' },
                e('table', { className: 'op-table' },
                  e('thead', null,
                    e('tr', null,
                      e('th', null, 'S.No'), e('th', null, 'Name'), e('th', null, 'Discount'),
                      e('th', null, 'Offer Type'), e('th', null, 'Status'), e('th', null, 'Actions')
                    )
                  ),
                  e('tbody', null,
                    filteredOffers.map(function (offer, index) {
                      var status = getOfferStatus(offer);
                      return e('tr', { key: getOfferId(offer) },
                        e('td', null, index + 1),
                        e('td', { style: { fontWeight: 600 } }, offer.title),
                        e('td', { style: { fontWeight: 700 } }, discountLabel(offer)),
                        e('td', null, e('span', { className: 'op-badge active' }, 'First Order')),
                        e('td', null, e('span', { className: 'op-badge ' + status.toLowerCase() }, status)),
                        e('td', null,
                          e('div', { className: 'act-menu' },
                            e('button', { type: 'button', className: 'act-menu-btn', onClick: function (ev) { ev.stopPropagation(); var rect = ev.currentTarget.getBoundingClientRect(); setMenuPos({ top: rect.bottom + 6, right: window.innerWidth - rect.right }); toggleMenu(getOfferId(offer)); } }, '\u22EE'),
                            openMenuId === getOfferId(offer)
                              ? e('div', { className: 'act-menu-dd', style: { top: menuPos.top, right: menuPos.right }, onClick: function (ev) { ev.stopPropagation(); } },
                                  e('button', { type: 'button', className: 'act-menu-item', onClick: function () { setOpenMenuId(null); setViewingOffer(offer); } }, e('span', null, e(EyeIcon)), 'View'),
                                  e('button', { type: 'button', className: 'act-menu-item', onClick: function () { setOpenMenuId(null); startEdit(offer); } }, e('span', null, e(PencilIcon)), 'Edit'),
                                  e('button', { type: 'button', className: 'act-menu-item act-menu-delete', onClick: function () { setOpenMenuId(null); setPendingDeleteOffer(offer); } }, e('span', null, e(TrashIcon)), 'Delete')
                                )
                              : null
                          )
                        )
                      );
                    })
                  )
                )
              )
      )
    ),

    showForm
      ? e('div', { className: 'op-modal-overlay', onClick: function (ev) { if (ev.target === ev.currentTarget) resetForm(); } },
          e('div', { className: 'op-modal', onClick: function (ev) { ev.stopPropagation(); } },
            e('div', { className: 'op-modal-header' },
              e('h3', { className: 'op-modal-title' }, 'Add New Offer'),
              e('button', { type: 'button', className: 'op-modal-close', onClick: resetForm }, e(XIcon))
            ),
            e('form', { onSubmit: handleSubmit },
              renderFormFields(),
              e('div', { className: 'op-submit-row' },
                e('button', { type: 'button', className: 'op-reset', onClick: resetForm }, 'Cancel'),
                e('button', { type: 'submit', className: 'op-submit', disabled: submitting }, submitting ? 'Creating...' : 'Create Offer')
              )
            )
          )
        )
      : null,
    viewingOffer
      ? e('div', { className: 'op-modal-overlay', onClick: function (ev) { if (ev.target === ev.currentTarget) setViewingOffer(null); } },
          e('div', { className: 'op-modal' },
            e('div', { className: 'op-modal-header' },
              e('h3', { className: 'op-modal-title' }, viewingOffer.title),
              e('button', { type: 'button', className: 'op-modal-close', onClick: function () { setViewingOffer(null); } }, e(XIcon))
            ),
            e('div', { className: 'op-modal-grid' },
              e('div', null, e('p', { className: 'op-modal-lbl' }, 'Discount'), e('p', { className: 'op-modal-val' }, discountLabel(viewingOffer)))
            ),
            viewingOffer.description
              ? e('div', { style: { marginBottom: '16px' } },
                  e('p', { className: 'op-modal-lbl' }, 'Description'),
                  e('p', { className: 'op-modal-val' }, viewingOffer.description)
                )
              : null,
            e('div', { className: 'op-modal-grid' },
              e('div', null, e('p', { className: 'op-modal-lbl' }, 'Offer Type'), e('p', { className: 'op-modal-val' }, 'First Order Only')),
              e('div', null, e('p', { className: 'op-modal-lbl' }, 'Status'), e('p', { className: 'op-modal-val' }, getOfferStatus(viewingOffer)))
            )
          )
        )
      : null,

    showEditModal
      ? e('div', { className: 'op-modal-overlay', onClick: function (ev) { if (ev.target === ev.currentTarget) resetForm(); } },
          e('div', { className: 'op-modal', onClick: function (ev) { ev.stopPropagation(); } },
            e('div', { className: 'op-modal-header' },
              e('h3', { className: 'op-modal-title' }, 'Edit Offer'),
              e('button', { type: 'button', className: 'op-modal-close', onClick: resetForm }, e(XIcon))
            ),
            e('form', { onSubmit: handleSubmit },
              renderFormFields(),
              e('div', { className: 'op-submit-row' },
                e('button', { type: 'button', className: 'op-reset', onClick: resetForm }, 'Cancel'),
                e('button', { type: 'submit', className: 'op-submit', disabled: submitting }, submitting ? 'Saving...' : 'Save Changes')
              )
            )
          )
        )
      : null,

    pendingDeleteOffer
      ? e('div', { className: 'op-modal-overlay', onClick: function (ev) { if (ev.target === ev.currentTarget && !deleting) setPendingDeleteOffer(null); } },
          e('div', { className: 'op-confirm-box', onClick: function (ev) { ev.stopPropagation(); } },
            e('h3', { className: 'op-modal-title' }, 'Confirm Delete'),
            e('p', { style: { margin: '16px 0 0', color: '#C4B5FD', lineHeight: 1.6 } },
              'Are you sure you want to delete ', e('strong', null, '"' + pendingDeleteOffer.title + '"'), '? This action cannot be undone.'
            ),
            e('div', { className: 'op-confirm-actions' },
              e('button', { type: 'button', className: 'op-confirm-btn cancel', disabled: deleting, onClick: function () { setPendingDeleteOffer(null); } }, 'Cancel'),
              e('button', { type: 'button', className: 'op-confirm-btn confirm', disabled: deleting, onClick: confirmDelete }, deleting ? 'Deleting\u2026' : 'Delete Offer')
            )
          )
        )
      : null
  );
};

export default Offers;


